import { AdminBarberRepository } from "../../Repository";

export async function clickOnResetPassword(
  email: string,
  repository: AdminBarberRepository
): Promise<boolean> {
  return repository.resetPassword(email);
}
